// @ts-nocheck
import { TELCO } from "constants/common";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import actions from "redux/home/actions";
import { removeUnicode, urlAssetsCustom } from "utils/common";
const PopupGiftPhycial = (props) => {
  const {
    dataGift,
    code,
    setIsShowPopupGiftPhycial,
    setIsLoading,
    checkError,
  } = props;
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [identityNumber, setIdentityNumber] = useState("");
  const [address, setAddress] = useState("");
  const isEnableButton = useRef(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (
      name?.trim()?.length &&
      address?.trim()?.length &&
      identityNumber?.trim()?.length
    ) {
      removeDisableBtn("#btn-confirm");
    } else {
      addDisableBtn("#btn-confirm");
    }
  }, [name, dataGift, address, identityNumber]);

  const addDisableBtn = (id) => {
    const el = document.querySelector(id);
    el.classList.add("disabled");
    isEnableButton.current = false;
  };

  const removeDisableBtn = (id) => {
    const el = document.querySelector(id);
    el.classList.remove("disabled");
    isEnableButton.current = true;
  };

  const handleSubmit = () => {
    let dataSubmit = {
      identityCard: identityNumber,
      name: name,
      code,
      address,
    };
    setIsLoading(true);
    dispatch(
      actions.UPDATE_DELIVERY.request(
        dataSubmit,
        (res) => {
          setIsLoading(false);
          setIsShowPopupGiftPhycial(false);
        },
        (err) => {
          setIsLoading(false);
          setIsShowPopupGiftPhycial(false);
          checkError(err);
        }
      )
    );
  };
  return (
    <>
      <div className="popup-overlay modal-notify">
        <div className="popup-warp">
          <div className="icon-popup"></div>
          <div className="popup-inner">
            <div className="content-popup">
              <h5>thông tin nhận giải</h5>
              <img
                style={{ height: "36vw" }}
                className="img-modal"
                src={dataGift?.giftImg}
                alt="200.png"
              />

              <h3 className="name-gift">{dataGift?.giftName}</h3>
              {/* <p>
                Vui lòng giữ lại thẻ in mã quay thưởng và điền thông tin nhận
                thưởng sau:
              </p> */}

              <form
                style={{ marginTop: 10 }}
                className="phycial-form"
                onSubmit={props.handleSubmit}
              >
                <div className="form-group">
                  <label className="title-form" htmlFor="phone">
                    Họ và tên <span>*</span>
                  </label>

                  <div className="form-field">
                    <input
                      type="text"
                      className={`form-control`}
                      id="phone"
                      name="name"
                      placeholder="Nhập họ và tên"
                      min="0"
                      value={name}
                      onChange={(e) => {
                        setName(e?.target?.value);
                      }}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="title-form" htmlFor="CCCD">
                    CMND/CCCD <span>*</span>
                  </label>

                  <div className="form-field">
                    <input
                      type="tel"
                      className={`form-control `}
                      id="CCCD"
                      maxLength={12}
                      name="CCCD"
                      placeholder="Nhập CCCD/CMND..."
                      min="0"
                      max="12"
                      inputMode="numeric"
                      value={identityNumber}
                      onChange={(e) => {
                        setIdentityNumber(
                          e?.target?.value.replace(/[^\d]/gi, "")
                        );
                      }}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="title-form" htmlFor="usr">
                    Địa chỉ nhận giải <span>*</span>
                  </label>
                  <div className="form-field">
                    <input
                      type="text"
                      className="form-control"
                      id="usr"
                      name="address"
                      placeholder="Nhập địa chỉ..."
                      // maxLength={50}
                      min="0"
                      // max="50"
                      value={address}
                      onChange={(e) => {
                        setAddress(e?.target?.value);
                      }}
                    />
                  </div>
                </div>
                {/* <div className="form-group errors-text-2">
                  <label className="title-form" htmlFor="CCCD">
                    Vui lòng chọn cửa hàng TH true mart để nhận thưởng
                  </label>
                </div>
                <div className="form-group">
                  <label className="title-form" htmlFor="usr">
                    Tỉnh/Thành phố <span>*</span>
                  </label>

                  <Select
                    className={`form-control  `}
                    placeholder="Chọn"
                    isClearable={true}
                    options={provinces}
                    value={provinces.filter(
                      ({ city }) => city === provincePopupTmpSelected?.city
                    )}
                    onChange={(e) => {
                      console.log(e);
                      setProvincePopupSelected(e);
                      onChangeProvincePopupSelected(e?.code);
                      // props.setValue("address", e?.code);
                      // props?.clearFieldFormData("address");
                    }}
                    onMenuOpen={() => {
                      setProvincePopupTmpSelected(null);
                    }}
                    onMenuClose={() => {
                      setProvincePopupTmpSelected(provincePopupSelected);
                    }}
                  />
                </div>
                <div className="form-group">
                  <label className="title-form" htmlFor="usr">
                    Quận/Huyện <span>*</span>
                  </label>

                  <Select
                    className={`form-control  `}
                    placeholder="Chọn"
                    isClearable={true}
                    options={districts}
                    value={districts.filter(
                      ({ name }) => name === districtPopupTmpSelected?.name
                    )}
                    onChange={(e) => {
                      console.log(e);
                      setDistrictsPopupSelected(e);
                      onChangeDistrictsPopupSelected(e?.id);
                      // props.setValue("address", e?.code);
                      // props?.clearFieldFormData("address");
                    }}
                    onMenuOpen={() => {
                      setDistrictPopupTmpSelected(null);
                    }}
                    onMenuClose={() => {
                      setDistrictPopupTmpSelected(districtsPopupSelected);
                    }}
                  />
                </div>
                <div className="form-group">
                  <label className="title-form" htmlFor="usr">
                    Địa chỉ nhận giải <span>*</span>
                  </label>

                  <Select
                    className={`form-control zindex-1 `}
                    placeholder="Nhập địa chỉ..."
                    isClearable={true}
                    options={marts}
                    value={marts.filter(
                      ({ address }) =>
                        address === martsPopupTmpSelected?.address
                    )}
                    onChange={(e) => {
                      console.log(e);
                      setMartsPopupSelected(e);
                      // onChangeDistrictsPopupSelected(e?.id);
                      // props.setValue("address", e?.code);
                      // props?.clearFieldFormData("address");
                    }}
                    onMenuOpen={() => {
                      setMartsPopupTmpSelected(null);
                    }}
                    onMenuClose={() => {
                      setMartsPopupTmpSelected(martsPopupSelected);
                    }}
                  />
                </div> */}
              </form>

              {/* <p className="content-note">
                Lưu ý: Khách hàng vui lòng điền thông tin chính xác để nhận giải
                thưởng, chúng tôi không chịu trách nhiệm nếu thông tin không
                chính xác. <br />
                Liên hệ:
                <strong className="text-red">1800 54 54 18 - Phím 4</strong>
              </p> */}
            </div>
            <div className="btn-wrapper btn-center zindex-0">
              <button
                onClick={handleSubmit}
                type="button"
                className="btn btn-primary btn-block disabled"
                id="btn-confirm"
              >
                <a> HOÀN TẤT</a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PopupGiftPhycial;
